import { SCHEMA_VERSION } from './migrate';
import type { ChronoDocument } from './types';

export function createEmptyDocument(now: Date = new Date()): ChronoDocument {
  return {
    schemaVersion: SCHEMA_VERSION,
    meta: { savedAt: now.toISOString(), appVersion: __APP_VERSION__ },
    categories: {},
    bands: [],
    items: [],
  };
}

/** Stamps the document as saved. Phase 3 calls this on the way to the file. */
export function withSavedAt(doc: ChronoDocument, now: Date = new Date()): ChronoDocument {
  return { ...doc, meta: { savedAt: now.toISOString(), appVersion: __APP_VERSION__ } };
}

export function serialize(doc: ChronoDocument): string {
  return JSON.stringify(doc, null, 2);
}
